// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import atoolEntity from './entities/atool.json';
import atoolMenu from '../pages/atool/menu.json';
import atoolFullForm from '../pages/atool/forms/full.json';
import atoolContextForm from '../pages/atool/forms/context.json';
import atoolMiniForm from '../pages/atool/forms/mini.json';
import atoolLookupForm from '../pages/atool/forms/lookup.json';
import atoolTableView from '../pages/atool/views/table.json';
import atoolStagesView from '../pages/atool/views/stages.json';
import atoolCardsView from '../pages/atool/views/cards.json';
import atoolInlineView from '../pages/atool/views/inline.json';
import atoolBacklogView from '../pages/atool/views/backlog.json';
import atoolSplitView from '../pages/atool/views/split.json';
import atoolCalendarView from '../pages/atool/views/calendar.json';
import atoolDashboardView from '../pages/atool/views/dashboard.json';

/** Тип запису «Аналіз» зі сторінками пакета: меню, форми та подання з pages/atool/. */
export const atoolDefinition: IRecordTypeDefinition = {
  ...atoolEntity,
  views: assembleViewSet({
      table: atoolTableView,
      stages: atoolStagesView,
      cards: atoolCardsView,
      inline: atoolInlineView,
      backlog: atoolBacklogView,
      split: atoolSplitView,
      calendar: atoolCalendarView,
      dashboard: atoolDashboardView,
  }),
  form: atoolFullForm,
  forms: { full: atoolFullForm, context: atoolContextForm, mini: atoolMiniForm, lookup: atoolLookupForm },
  menu: atoolMenu,
} as IRecordTypeDefinition;
